import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import { Provider } from 'react-redux';
import { CacheProvider, NetworkErrorBoundary } from 'rest-hooks';
import { PersistGate } from 'redux-persist/integration/react';
import store, { persistor } from './store/storeConfig';

import BulkStoryTaggingContainer from './components/admin2/bulk_story_tagging/bulk_story_tagging_container';
import Comments from './components/comments/comments';
import ContentPortal from './components/content_portals/content_portal';
import ContentPortals from './components/content_portals/content_portals';
import ContentRequests from './components/content_requests/content_requests';
import EditBriefTemplate from './components/brief_templates/edit_brief_template';
import EditContentRequestForm from './components/content_request_forms/edit_content_request';
import Footer from './components/layout/Footer';
import IntegrationFormWrapper from './components/integrations/IntegrationFormWrapper';
import IntegrationsList from './components/integrations/IntegrationsList';
import Nav from './components/nav/nav';
import BasicNav from './components/nav/basic_nav';
import NewBriefTemplate from './components/brief_templates/new_brief_template';
import NewContentRequest from './components/content_requests/new_content_request';
import NewContentRequestForm from './components/content_request_forms/new_content_request';
import ReassignUsersContainer from './components/reassign_users/reassign_users_container';
import StoryAlreadyClaimedContainer from './components/story_already_claimed/story_already_claimed';
import RecommendationsContainer from './components/recommendations/recommendations_container';
import ValueWrapper from './components/value/value_wrapper';
import StoryLevelWrapper from './components/story_level_value/story_level_wrapper';
import ShowContentRequest from './components/content_requests/show_content_request';
import TransactionSummary from './components/transactions/transaction_summary';
import StoryShow from '../client/pages/ShowPage';
import StoryShowCommentsWrapper from '../client/components/textEditor/StoryShowCommentsWrapper';
import LoadingSpinner from '../utils/shared/LoadingSpinner';
import OnHoldSwitch from '../client/components/onHoldPortal';
import PaymentCancellation from '../client/components/PaymentCancellation';

// All components except for Nav, which is handled by AppRouter below
const apps = {
  BasicNav,
  BulkStoryTaggingContainer,
  Comments,
  ContentPortal,
  ContentPortals,
  ContentRequests,
  EditBriefTemplate,
  EditContentRequestForm,
  Footer,
  IntegrationFormWrapper,
  IntegrationsList,
  NewBriefTemplate,
  NewContentRequest,
  NewContentRequestForm,
  OnHoldSwitch,
  ReassignUsersContainer,
  StoryAlreadyClaimedContainer,
  RecommendationsContainer,
  ValueWrapper,
  StoryLevelWrapper,
  ShowContentRequest,
  StoryShow,
  StoryShowCommentsWrapper,
  TransactionSummary,
  PaymentCancellation
};

export default () => {
  const appEls = Array.from(document.querySelectorAll('.app'));
  appEls.forEach(el => {
    const componentName = el.getAttribute('data-component');
    const appData = el.getAttribute('data-props');
    const App = apps[componentName];
    if (App) {
      ReactDOM.render(
        <CacheProvider>
          <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
              <Suspense fallback={<LoadingSpinner />}>
                <NetworkErrorBoundary>
                  <App appData={appData} />
                </NetworkErrorBoundary>
              </Suspense>
            </PersistGate>
          </Provider>
        </CacheProvider>,
        el
      );
    }
  });

  const appRouterEl = document.getElementById('app-router');
  if (appRouterEl) {
    const AppRouter = () => (
      <Router>
        <Route path="/" component={Nav} />
      </Router>
    );

    ReactDOM.render(<AppRouter />, appRouterEl);
  }
};



// WEBPACK FOOTER //
// ./app/javascript/app/index.jsx